<template>
  <path fill-rule="evenodd" d="M58.537.838C50.253.588 17.074.745 8.621 11.105-3.18 25.57-2.887 54.021 19.235 60.621c20.322 6.063 46.524 8.777 56.276 9.072 6.367.193 39.326-1.9 51.689-12.402 8.683-7.377 8.545-20.539-.376-35.876C118.017 4.538 64.144 1.008 58.537.838z"/>
</template>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// components/_SVG/ShapeYearBtn3Mob.vue